<template>
  <pt-life-experience-pavilion-reservation class="pt-life-experience-pavilion-reservation__page"></pt-life-experience-pavilion-reservation>
</template>

<script>
import PtLifeExperiencePavilionReservation from 'cps/appointment-application/pt-life-experience-pavilion-reservation/withData'
export default {
  name: 'pt-life-experience-pavilion-reservation__view',
  components: {
    'pt-life-experience-pavilion-reservation': PtLifeExperiencePavilionReservation
  }
}
</script>
